exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-item[data-v-bf7df61e]{display:inline-block;margin-right:10px}.list-enter-active[data-v-bf7df61e],.list-leave-active[data-v-bf7df61e]{transition:all 1s}.list-enter[data-v-bf7df61e],.list-leave-to[data-v-bf7df61e]{opacity:0;transform:translateY(-30px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bf7df61e","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/core/components/mdNotifications/index.vue
// module id = 07E7
// module chunks = 13 14